import { buildApiUrl } from '../utils/apiConfig';
import { apiClient } from "../utils/apiClient";

/**
 * Platform-wide feature flags from GET /api/app/features.
 */
export interface AppFeatures {
    recruitingCalendarEnabled: boolean;
    instantChatEnabled: boolean;
    collegeFinderEnabled?: boolean;
    collegeChatSearchEnabled?: boolean;
}

const defaultHeaders = { 'Content-Type': 'application/json' };
const defaultOptions: RequestInit = { credentials: 'include', headers: defaultHeaders };

/**
 * Fetches platform feature flags for the authenticated session.
 * Callers should fail open (treat missing flags as enabled) so content is not
 * hidden when the endpoint is temporarily unavailable.
 */
export async function getAppFeatures(): Promise<AppFeatures> {
    const res = await apiClient(buildApiUrl('api/app/features'), defaultOptions);
    if (!res.ok) {
        throw new Error(`Failed to fetch app features: ${res.status}`);
    }
    return (await res.json()) as AppFeatures;
}
